export const SEQUENCING_MATCH_GROUPED_TEXT_REGEX = /({[^}]*})/g;
export const SEQUENCING_MATCH_BRACES_REGEX = /({|})/g;
